// frontend/src/services/shopier.service.ts
// Shopier Ödeme İstemci Servisi

import { authService } from './auth.service';

const API_BASE =
  import.meta.env.PROD &&
  (import.meta.env.VITE_API_BASE_URL === 'http://localhost:8080' || !import.meta.env.VITE_API_BASE_URL)
    ? ''
    : import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080';

export const SHOPIER_PRODUCT_URLS: Record<string, string> = {
  'premium':         'https://www.shopier.com/minikcoder/49962787',
  'premium-plan':    'https://www.shopier.com/minikcoder/49962787',
  'pro':             'https://www.shopier.com/minikcoder/49962864',
  'pro-plan':        'https://www.shopier.com/minikcoder/49962864',
  'parent':          'https://www.shopier.com/minikcoder/49962836',
  'parent-plan':     'https://www.shopier.com/minikcoder/49962836',
  'veli':            'https://www.shopier.com/minikcoder/49962836',
  'veli-plan':       'https://www.shopier.com/minikcoder/49962836',
  'parent_standard': 'https://www.shopier.com/minikcoder/49962836',
  'parent_plus':     'https://www.shopier.com/minikcoder/49962836',
};

export function getShopierUrlForPlan(planIdentifier: string, planName?: string): string {
  const cleanId = (planIdentifier || '').toLowerCase().trim();
  const cleanName = (planName || '').toLowerCase().trim();

  if (SHOPIER_PRODUCT_URLS[cleanId]) return SHOPIER_PRODUCT_URLS[cleanId];
  if (cleanId.includes('pro') || cleanName.includes('pro')) return SHOPIER_PRODUCT_URLS['pro'];
  if (cleanId.includes('veli') || cleanId.includes('parent') || cleanName.includes('veli') || cleanName.includes('parent')) return SHOPIER_PRODUCT_URLS['parent'];
  return SHOPIER_PRODUCT_URLS['premium'];
}

export interface ShopierInitiateResponse {
  success: boolean;
  platform_order_id: string;
  payment_url?: string;
  form?: {
    action_url: string;
    fields: Record<string, string>;
  };
}

class ShopierClientService {
  /**
   * Shopier ödeme oturumunu başlatır: Kullanıcıyı doğrudan Shopier ürün sayfasına yönlendirir.
   */
  async startPayment(planId: string, planName?: string, billingPeriod: 'monthly' | 'yearly' = 'monthly'): Promise<void> {
    const directUrl = getShopierUrlForPlan(planId, planName);

    // Arka planda sipariş kaydını oluşturmaya çalış (sessiz bildirim)
    try {
      const token = await authService.getAccessToken();
      if (token) {
        fetch(`${API_BASE}/api/payment/shopier/initiate`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ planId, planName, billingPeriod }),
        }).catch(() => {});
      }
    } catch {}

    // Doğrudan Shopier resmi ürün sayfasına yönlendir (509 hatasını %100 engeller)
    window.location.href = directUrl;
  }
}

export const shopierService = new ShopierClientService();
